import React from 'react';
import { IconLoader } from 'common/IconLoader';
import Modal from 'components/shared/Modal/Modal';
import PasswordInput from 'components/shared/PasswordInput/PasswordInput';
import { Status } from 'common/utils/constants';
import SvgAF from 'components/shared/SvgAF/SvgAF';

const WiFiAccessPointModal = (props) => {
  return (
    <Modal closeTargetRef={null} close={props.close} animate={false} animateX={false} opaque={true} height={302}>
      <div className="accessModal">
        <div className="wifiModalHeader">
          <div className="wifiModalTitle">Access point</div>
        </div>
        <div className="wifiModalBody">
          <div className="wifiAccessPointTitle">Name</div>
          <input
            defaultValue={props.accessPointNameValue}
            onChange={(evt) => props.setAccessPointNameValue(evt.target.value)}
            className="wifiAccessPointInput"
          ></input>

          <div className="wifiPasswordTitle">Password</div>
          <PasswordInput
            showButton
            defaultPassword={props.accessPointPasswordValue}
            passwordValue={(val) => props.setAccessPointPasswordValue(val)}
          />
        </div>
        <div className="wifiModalFooter">
          {props.accessModalStatus !== Status.FAILURE && (
            <div className="wifiModalConfirmSection">
              <button
                onClick={() => {
                  props.setIsWifiAccessPointModalOpen(false);
                  props.setWifiDisabledTimerValue(0);
                  props.wifiEnabledTimerValue(0);
                }}
                className="Global_CancelButton wifiCancelButton"
              >
                Cancel
              </button>
              <button onClick={() => props.applyWifiAccessPoint()} className="Global_ApplyButton wifiApplyButton">
                {props.accessModalStatus === Status.NONE && 'Apply'}
                {props.accessModalStatus === Status.PENDING && (
                  <img alt="" className="Global_Spinner" src={IconLoader.icon_spinner_small} />
                )}
                {props.accessModalStatus === Status.SUCCESS && 'Applied'}
              </button>
            </div>
          )}
          {props.accessModalStatus === Status.FAILURE && (
            <div className="wifiModalErrorBox">
              <img src={IconLoader.icon_failed_medium} alt="" />
              <div className="wifiModalErrorMessageBlock">
                <span>{props.accessModalErrorMessage}</span>
              </div>
              <SvgAF
                onClick={() => {
                  props.setAccessModalStatus(Status.NONE);
                }}
                img={IconLoader.icon_close_mid}
                hover={IconLoader.icon_close_mid_hover}
              />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default WiFiAccessPointModal;
